import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { BreadStyle } from "./BreadStyle";
const BreadCrumb = ({
  num1,
  num2,
  num3,
  num4,
  href1,
  href2,
  href3,
  href4,
  margin,
}) => {
  return (
    <BreadStyle className={margin}>
      <Breadcrumb>
        {num1 ? <Breadcrumb.Item href={href1}>{num1}</Breadcrumb.Item> : null}
        {num2 ? <Breadcrumb.Item href={href2}>{num2}</Breadcrumb.Item> : null}
        {num3 ? <Breadcrumb.Item href={href3}>{num3}</Breadcrumb.Item> : null}
        {num4 ? <Breadcrumb.Item href={href4}>{num4}</Breadcrumb.Item> : null}
      </Breadcrumb>
    </BreadStyle>
  );
};

export default BreadCrumb;
